import { render, staticRenderFns } from "./CompanionGuideDetail.vue?vue&type=template&id=6498c1d3&scoped=true&lang=pug&"
import script from "./CompanionGuideDetail.vue?vue&type=script&lang=js&"
export * from "./CompanionGuideDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanionGuideDetail.vue?vue&type=style&index=0&id=6498c1d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6498c1d3",
  null
  
)

export default component.exports